import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Truck } from 'lucide-react';

import { usePaymentHistoryCxp } from '../hooks/usePaymentHistoryCxp';

import PaymentHistoryTableSection from './sections/PaymentHistoryTableSection';
import PaymentHistorySummarySection from './sections/PaymentHistorySummarySection';
import HistorySupplierSelector from './HistorySupplierSelector';
import ButtonCustom from '../../../../pages/UiElements/ButtonCustom';

interface Props {
  payableId?: number;
}

const PaymentHistoryForm = ({ payableId }: Props) => {
  const navigate = useNavigate();

  const { history, fetchPaymentHistory, clearHistory } = usePaymentHistoryCxp();

  const isContextMode = !!payableId;

  useEffect(() => {
    if (!payableId) return;

    fetchPaymentHistory(payableId);
  }, [payableId]);

  const handleBackToBalances = () => {
    clearHistory();

    navigate('/finance/cxp/supplier-balances');
  };

  if (!isContextMode && !history) {
    return <HistorySupplierSelector />;
  }

  if (!history) return null;

  return (
    <div>
      {/* 🔹 ENCABEZADO */}
      <div className="flex flex-wrap items-center justify-between gap-4 bg-danger/5 px-6 py-5">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-danger text-white">
            <Truck className="h-5 w-5" />
          </span>
          <div>
            <h2 className="font-semibold text-black dark:text-white">
              Historial de Pagos a Proveedores
            </h2>
            <p className="text-sm text-body dark:text-bodydark2">
              Pagos aplicados a esta cuenta por pagar
            </p>
          </div>
        </div>

        <ButtonCustom
          text="Volver a cuentas por pagar"
          onClick={handleBackToBalances}
          iconKey="arrowleft"
          variant="danger"
          size="sm"
          rounded="md"
          outline
        />
      </div>

      <div className="divide-y divide-stroke dark:divide-strokedark">
        <PaymentHistorySummarySection data={history} />

        <PaymentHistoryTableSection payments={history.payments || []} />
      </div>
    </div>
  );
};

export default PaymentHistoryForm;
